export enum OwnerType {
  Person = 1,
  Bussiness = 2,
}
